import { render, staticRenderFns } from "./informacionGeneral.vue?vue&type=template&id=2ef0d39b&scoped=true"
import script from "./informacionGeneral.vue?vue&type=script&lang=js"
export * from "./informacionGeneral.vue?vue&type=script&lang=js"
import style0 from "./informacionGeneral.vue?vue&type=style&index=0&id=2ef0d39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0d39b",
  null
  
)

export default component.exports